import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import * as PropTypes from 'prop-types';
import * as React from 'react';

var _excluded = ["children", "variant"];

/* eslint-disable @typescript-eslint/no-explicit-any */

/* eslint-enable @typescript-eslint/no-explicit-any */

var ButtonAction = /*#__PURE__*/React.forwardRef((props, ref) => {
  var {
      children,
      variant
    } = props,
    attributes = _objectWithoutProperties(props, _excluded);
  var variants = ['emphasis', 'subtle'
  // Note: "default" is not included in the classname
  ];

  // Add button classname
  attributes.className += variants.indexOf(variant) !== -1 ? " btn-action--".concat(variant) : ' btn-action';

  // Remove leading space when className is empty
  attributes.className = attributes.className.trim();
  if (typeof attributes.type === 'undefined') {
    attributes.type = 'button';
  }

  // eslint-disable-next-line react/button-has-type
  return /*#__PURE__*/React.createElement("button", _extends({}, attributes, {
    ref: ref,
    "data-hcid": "buttonaction-".concat("10.6.2")
  }), children);
});
ButtonAction.displayName = 'ButtonAction';
ButtonAction.defaultProps = {
  className: '',
  variant: 'default'
};
ButtonAction.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  id: PropTypes.string,
  onClick: PropTypes.func,
  type: PropTypes.oneOf(['button', 'reset', 'submit', '']),
  variant: PropTypes.oneOf(['default', 'emphasis', 'subtle'])
};
var ButtonActionDefault = props => /*#__PURE__*/React.createElement(ButtonAction, _extends({}, props, {
  variant: "default"
}));
var ButtonActionEmphasis = props => /*#__PURE__*/React.createElement(ButtonAction, _extends({}, props, {
  variant: "emphasis"
}));
var ButtonActionSubtle = props => /*#__PURE__*/React.createElement(ButtonAction, _extends({}, props, {
  variant: "subtle"
}));

export { ButtonAction, ButtonActionDefault, ButtonActionEmphasis, ButtonActionSubtle };
